export default __webpack_public_path__ + "images/IZ.ec9fa39.png";